import * as types from '../actions/actionTypes';

const initialState = {
    payload: {

        countries: [],
        countryFinInfo:[],
        countryFullInfo:[],
        highlights: {},
        comparison: null,
        forecast: {},
        forecastAccuracy: {},
        syncStatus: null,
        regions: []
    },
    loading: false,
    error: null,
    success: null
}

const countries = (state = initialState, action) => {    
    switch (action.type) {
        case types.GET_COUNTRIES_REQUEST:
            return { ...state, loading: true, success: false };
        case types.GET_COUNTRIES_SUCCESS:
            return { ...state, loading: false, success: true, payload: {...state.payload, countries: action.payload } };
        case types.GET_COUNTRIES_FAILURE:
            return { ...state, loading: false, success: false, error: action.error };
        case types.GET_REGIONS_REQUEST:
            return { ...state, loading: true, success: false };
        case types.GET_REGIONS_SUCCESS:
            return { ...state, loading: false, success: true, payload: { ...state.payload, regions: action.payload } };
        case types.GET_REGIONS_FAILURE:
            return { ...state, loading: false, success: false, error: action.error };
        case types.GET_COUNTRY_FIN_INFO_REQUEST:
        case types.GET_COUNTRY_FULL_INFO_REQUEST:
            return { ...state, loading: true, success: false };
        case types.GET_COUNTRY_FIN_INFO_SUCCESS: { 
            let org = Array.from(state.payload.countryFinInfo);            
            const index =  org.indexOf(x => x.countryCode === action.payload.countryCode);
            if (index > 0) {
                org[index] = action.payload;
            }
            else {
                org.push(action.payload);
            }
            return { ...state, loading: false, success: true, payload: { ...state.payload, countryFinInfo: org } };
        }
        case types.GET_COUNTRY_FULL_INFO_SUCCESS: {             
            let org = Array.from(state.payload.countryFullInfo);            
            const index =  org.indexOf(x => x.countryCode === action.payload.countryCode);
            if (index > 0) {
                org[index] = action.payload;
            }
            else {
                org.push(action.payload);
            }
            return { ...state, loading: false, success: true, payload: { ...state.payload, countryFullInfo: org } };
        }
        case types.GET_COUNTRY_FIN_INFO_FAILURE:
        case types.GET_COUNTRY_FULL_INFO_FAILURE:
            return { ...state, loading: false, success: false, error: action.error };
        case types.GET_COUNTRY_HIGHLIGHTS_REQUEST:
        case types.GET_COUNTRY_COMPARISON_REQUEST:
        case types.GET_COUNTRY_FORECAST_REQUEST:
        case types.GET_FORECAST_ACCURACY_REQUEST:
        case types.GET_DATA_SYNC_STATUS_REQUEST:
            return { ...state, loading: true, success: false };
        case types.GET_COUNTRY_HIGHLIGHTS_SUCCESS: {
            const highlights = { ...state.payload.highlights, [action.payload.countryCode]: action.payload.highlights };
            return { ...state, loading: false, success: true, payload: { ...state.payload, highlights } };
        }
        case types.GET_COUNTRY_COMPARISON_SUCCESS:
            return { ...state, loading: false, success: true, payload: { ...state.payload, comparison: action.payload } };
        case types.GET_COUNTRY_FORECAST_SUCCESS: {
            const forecast = { ...state.payload.forecast, [action.payload.countryCode]: action.payload.forecast };
            return { ...state, loading: false, success: true, payload: { ...state.payload, forecast } };
        }
        case types.GET_FORECAST_ACCURACY_SUCCESS: {
            const forecastAccuracy = { ...state.payload.forecastAccuracy, [action.payload.countryCode]: action.payload.runs };
            return { ...state, loading: false, success: true, payload: { ...state.payload, forecastAccuracy } };
        }
        case types.GET_DATA_SYNC_STATUS_SUCCESS:
            return { ...state, loading: false, success: true, payload: { ...state.payload, syncStatus: action.payload } };
        case types.GET_COUNTRY_HIGHLIGHTS_FAILURE:
        case types.GET_COUNTRY_COMPARISON_FAILURE:
        case types.GET_COUNTRY_FORECAST_FAILURE:
        case types.GET_FORECAST_ACCURACY_FAILURE:
        case types.GET_DATA_SYNC_STATUS_FAILURE:
            return { ...state, loading: false, success: false, error: action.error };
        default:
            return { ...state, loading: false, error: null, success: false };
    }
}

export default countries;